import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from "reactstrap";
import { FuelType, VesselMachineryList } from './VesselConfiguration.model';
import apiGlobal from '../../global/api.global';
import { useSelector } from 'react-redux';
import { RootState } from '../../';
import { errorToast, successToast } from '../../Components/Toasts';
import { errResponse } from 'GenericForms/Helper';

const Fuels = () => {
    const [fuelTypes, setFuelTypes] = useState<Array<FuelType>>([]);
    const [fuelSettings, setFuelSettings] = useState<Array<any>>([]);
    const [fuelSettOptions, setFuelSettOptions] = useState<Array<any>>([]);
    const [vesselMachineries, setVesselMachineries] = useState<Array<VesselMachineryList>>([]);
    const { VesselID } = useSelector((state: RootState) => state.Reporting);

    useEffect(() => {
        const loadFuelOptions = async () => {
            await apiGlobal.get(`/vessel_fuel_information/distinct_records_by_fuel_type/?vessel_id=${VesselID}`).then(res => {
                setFuelTypes(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
        }; loadFuelOptions();
    }, [VesselID]);

    useEffect(() => {
        const loadFuelSettings = async () => {
            await apiGlobal.get(`/vessel_fuel_setting/get_fuel_setting_by_vessel/?vessel_id=${VesselID}`).then(res => {
                setFuelSettOptions(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
        }; loadFuelSettings();
    }, [VesselID]);

    useEffect(() => {
        const loadMachineryOptions = async () => {
            await apiGlobal.get(`vessel_machinery_fc_group/get_vessel_machinery_fc_group_by_vessel/?vessel_id=${VesselID}`).then(res => {
                setVesselMachineries(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
        }; loadMachineryOptions();
    }, [VesselID]);

    function handle_Fuel_Change(e: any, fuelIdx: number, machine_id: number, fuel_id: number) {
        const Fuelcheckbox = document.getElementById(e.target.id) as HTMLInputElement;
        if (Fuelcheckbox) {
            Fuelcheckbox.checked = e.target.checked
        } else {
            console.error(`Checkbox with ID "${e.target.id}" not found.`);
        }
        fuelSettings.push({
            vessel_name: VesselID, vessel_machinery_fc_group: machine_id, fuel_name: fuel_id, selected: e.target.checked
        })

        const prevValues: any[] = [...fuelSettings]
        setFuelSettings(prevValues)
    }

    const Fuel_Settings_Submit = (e: any) => {
        if (fuelSettOptions.length > 0) {
            fuelSettOptions.map((sett: any) => {
                fuelSettings.filter((item: any) =>
                    item.vessel_machinery_fc_group === sett.vessel_machinery_fc_group && item.fuel_name === sett.fuel_name)
                    .map((fuelSett: any) => {
                        apiGlobal.put(`/vessel_fuel_setting/${sett.id}/`, fuelSett).then(res => {
                            successToast("Data saved successfully!")
                            return res;
                        }).catch(err => {
                            if (errResponse.includes(err.response.status)) {
                                errorToast("Internal error occured, please contact the admin");
                            }
                        });
                        return fuelSett;
                    })
                return sett;
            })
        } else {
            apiGlobal.post(`/vessel_fuel_setting/`, fuelSettings).then(res => {
                successToast("Data saved successfully!")
                return res;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
        }
    }

    return (
        <>
            <Row>
                <Col>
                    <div className="table-responsive mb-5">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Machinery name</th>
                                    {fuelTypes.length > 0 ?
                                        fuelTypes.map((fuelType: any, index: number) => {
                                            return (
                                                <th key={index}>{fuelType.fuel_type_name}</th>
                                            )
                                        })
                                        : <th>Please add fuels to this vessel</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {vesselMachineries.length > 0 ?
                                    vesselMachineries.map((vesselMachinery: any, index: number) => {
                                        return (
                                            <tr key={vesselMachinery.id}>
                                                <td>{index + 1}</td>
                                                <td>{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                                {fuelTypes.length > 0 ? fuelTypes.map((fuelType: any, fuelIndex: number) => {
                                                    return (
                                                        <td key={fuelIndex}><div className="form-check mb-3">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`${vesselMachinery.id}_${fuelType.id}`}
                                                                onChange={(e: any) => handle_Fuel_Change(e, fuelIndex, vesselMachinery.id, fuelType.fuel_type)}
                                                                defaultChecked={fuelSettOptions.length > 0 ? fuelSettOptions.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.fuel_name === fuelType.fuel_type && item.selected) : false}
                                                            />
                                                        </div>
                                                        </td>)
                                                })
                                                    : <td>Please add fuels for this vessel</td>}
                                            </tr>
                                        )
                                    })
                                    : <tr>
                                        <td>Please add machinery to this vessel</td>
                                    </tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                        <Button type="button" color='primary' className='pos-end' onClick={(e) => { Fuel_Settings_Submit(e) }}>Save</Button>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default Fuels;